import { action } from 'typesafe-actions';

export class Actions {
  requestType: string;
  actionType: any;

  constructor(reqType: string, actionType: any) {
    this.requestType = reqType;
    this.actionType = actionType;
  }
  setAction(type: 'R' | 'S' | 'E' | 'L') {
    const actionT = this.requestType + '_' + type;
    return this.actionType[actionT];
  }

  request(payload: Object) {
    // eslint-disable-next-line
    const actionType = this.setAction('R');
    return action(actionType, payload);
  }
  success(payload: Object) {
    // eslint-disable-next-line
    const actionType = this.setAction('S');
    return action(actionType, payload);
  }
  error(message: string) {
    // eslint-disable-next-line
    const actionType = this.setAction('E');
    return action(actionType, message);
  }

  loading(payload: boolean) {
    // eslint-disable-next-line
    const actionType = this.setAction('L');
    return action(actionType, payload);
  }
}
